import React from 'react';
import { shape } from 'prop-types';

export const StoreAddress = ({ address }) => {
  const {
    street,
    city,
    state,
    postalCode
  } = address;

  return (
    <div className="store-address">
      <div className="address-street">{street}</div>
      <div className="address-C-S-P">{city}, {state} {postalCode}</div>
    </div>
  );
};

StoreAddress.propTypes = {
  address: shape({})
};

StoreAddress.defaultProps = {
  address: {}
};